import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { db } from '../../../firebase';
import { doc, setDoc, collection, updateDoc, getDocs, query, where,getDoc } from 'firebase/firestore';
import Spinner from 'react-bootstrap/Spinner';

const EditCommandeModal = ({ show, handleClose, commande = {}, handleSave, plats = [] }) => {
    const [updatedCommande, setUpdatedCommande] = useState(commande);
    const [isUpdating, setIsUpdating] = useState(false); 

    // Créer un plat avec la quantité initiale
    useEffect(() => {
        if (commande.plats) {
            const platsWithInitialQuantity = commande.plats.map(plat => {
                // Trouver le plat correspondant dans la collection food-items pour récupérer les addons
                const platDetails = plats.find(p => p.nom === plat.nom);
                return {
                    ...plat,
                    addons: platDetails?.addons || [], // Ajouter les addons du plat
                    selectedAddons: plat?.addons || [], // Assurez-vous que selectedAddons est défini
                    quantiteInitiale: plat.quantite, // Stocke la quantité initiale
                };
            });
            setUpdatedCommande({ ...commande, plats: platsWithInitialQuantity });
        }
    }, [commande, plats]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedCommande(prevCommande => ({
            ...prevCommande,
            [name]: value,
        }));
    };

    const calculateTotal = (plats) => {
        return plats.reduce((sum, plat) => {
            // Vérifiez que plat.prix et plat.quantite sont des nombres
            const prix = parseFloat(plat.prix) || 0; // Utiliser 0 si plat.prix est undefined ou non numérique
            const quantite = parseFloat(plat.quantite) || 0; // Utiliser 0 si plat.quantite est undefined ou non numérique
    
            let platTotal = quantite * prix;
    
            // Ajouter le prix des addons sélectionnés
            if (plat.addons && plat.addons.length > 0) {
                plat.addons.forEach(addon => {
                    const addonDetails = plats.find(a => a.nom === addon.nom && a.module === addon.module);
                    if (addonDetails) {
                        const addonPrix = parseFloat(addonDetails.prix) || 0; // Assurez-vous que le prix est un nombre
                        platTotal += addonPrix;
                    }
                });
            }
    
            return sum + platTotal; // Gardez sum comme nombre
        }, 0).toFixed(2); // Appliquez toFixed à la fin
    };
    
    const handlePlatChange = (index, field, value) => {
        const updatedPlats = [...updatedCommande.plats];

        if (field === 'quantite') {
            updatedPlats[index][field] = value;
            updatedPlats[index].total = value * updatedPlats[index].prix;
        } else {
            updatedPlats[index][field] = value;
        }

        const newTotal = calculateTotal(updatedPlats);

        setUpdatedCommande(prevCommande => ({
            ...prevCommande,
            plats: updatedPlats,
            montant: newTotal,
        }));
    };

    const handleAddonChange = (platNom, moduleNom, module, addonNom) => {
        const updatedPlats = [...updatedCommande.plats];
        const platIndex = updatedPlats.findIndex(plat => plat.nom === platNom);
    
        if (platIndex !== -1) {
            let selectedAddons = updatedPlats[platIndex].selectedAddons || [];
            const addonIndex = selectedAddons.findIndex(addon => addon.nom === addonNom);
    
            if (addonIndex !== -1) {
                // Gestion de la sélection/désélection du module
                const selectedModules = selectedAddons[addonIndex].modules || [];
                const moduleExists = selectedModules.some(selected => selected.nom === moduleNom);
    
                if (moduleExists) {
                    selectedAddons[addonIndex].modules = selectedModules.filter(selected => selected.nom !== moduleNom);
                    if (selectedAddons[addonIndex].modules.length === 0) {
                        selectedAddons.splice(addonIndex, 1);  // Retirer l'addon si aucun module sélectionné
                    }
                } else {
                    selectedAddons[addonIndex].modules.push({ nom: moduleNom, prix: module.prix });
                }
            } else {
                selectedAddons.push({
                    nom: addonNom,
                    modules: [{ nom: moduleNom, prix: module.prix }],
                });
            }
    
            // Mettre à jour le plat avec les addons sélectionnés
            updatedPlats[platIndex] = {
                ...updatedPlats[platIndex],
                selectedAddons: selectedAddons.length > 0 ? selectedAddons : []  // Initialiser un tableau vide si pas d'addons
            };
    
            // Calculer le nouveau total
            const newTotal = calculateTotal(updatedPlats);
    
            // Mettre à jour la commande
            setUpdatedCommande(prevCommande => ({
                ...prevCommande,
                plats: updatedPlats,
                montant: newTotal,
            }));
        }
    };
    


    const handleRemovePlat = (index) => {
        const updatedPlats = updatedCommande.plats.filter((_, i) => i !== index);
        const newTotal = calculateTotal(updatedPlats);

        setUpdatedCommande(prevCommande => ({
            ...prevCommande,
            plats: updatedPlats,
            montant: newTotal,
        }));
    };

    const getEmailContent = async (id) => {
        try {
            const emailDoc = await getDoc(doc(db, 'email', id));
            if (emailDoc.exists()) {
                return emailDoc.data();
            } else {
                console.error('Document email non trouvé');
                return '';
            }
        } catch (error) {
            console.error('Erreur lors de la récupération de l\'email:', error);
            return '';
        }
    };
       


    const saveCommande = async (updatedCommande, isCancellation) => {
       
            const emailAnn = await getEmailContent('annulationCommande');
            const ModifEmail = await getEmailContent('modificationCommande');

       
        try {
            if (isCancellation) {
                // Si annulation, rembourser le montant total
                const refundResponse = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/refund', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ paymentIntentId: commande.paymentIntentId }),
                });


                const emailResponse = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/email-annulation', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            email: updatedCommande.email,
                            nom: updatedCommande.nom,
                            prenom: updatedCommande.prenom,
                            objet:emailAnn.objet,
                            emailContent:emailAnn.texte
                        }),
                    });
    
                if (!refundResponse.ok) {
                    const refundError = await refundResponse.text();
                    console.error(`Erreur lors du remboursement : ${refundResponse.status} - ${refundError}`);
                    throw new Error(`Erreur lors du remboursement : ${refundResponse.status} - ${refundError}`);
                }
    
                // Mettre à jour le statut de la commande à "annulé"
                commande.statut_commande = "Annulé";
                commande.statut_paiement = "Remboursé";
                commande.plats = commande.plats.map(plat => ({
                    id: plat.id,
                    taille: plat.taille,
                    total: plat.total,
                    nom: plat.nom,
                    prix: plat.prix,
                    quantite: plat.quantite,
                    instructions: plat.instructions,
                    selectedAddons: plat.addons 
                }));
               
                handleSave(commande); // Sauvegarder la commande annulée
    
                console.log('Commande annulée et remboursée avec succès');
                return;
            }
    
            // Si pas d'annulation, rembourser seulement la différence si le montant est inférieur
            if (updatedCommande.montant < commande.montant) {
                const refundAmount = commande.montant - updatedCommande.montant; // Différence à rembourser
    
                if (refundAmount > 0) { // Vérifiez que le montant à rembourser est positif
                    const refundResponse = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/refund', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ 
                            paymentIntentId: commande.paymentIntentId,
                            amount: Math.round(refundAmount * 100), // montant en centimes
                        }),
                    });
    
                    const emailResponse = await fetch('https://api-7zyk3qftka-uc.a.run.app/api/modif-email', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            email: updatedCommande.email,
                            nom: updatedCommande.nom,
                            prenom: updatedCommande.prenom,
                            plats: updatedCommande.plats,
                            total: updatedCommande.montant,
                            remboursse:refundAmount.toFixed(2),
                            date_commande: updatedCommande.date_service,
                            objet:ModifEmail.objet,
                            emailContent1:ModifEmail.texte,
                            emailContent2:ModifEmail.texte2
                        }),
                    });


                    if (!refundResponse.ok) {
                        const refundError = await refundResponse.text();
                        console.error(`Erreur lors du remboursement partiel : ${refundResponse.status} - ${refundError}`);
                        throw new Error(`Erreur lors du remboursement partiel : ${refundResponse.status} - ${refundError}`);
                    }
    
                    console.log(`Remboursement de ${refundAmount} effectué avec succès`);
                

                }
            }
            if (updatedCommande.montant == commande.montant) {

            }
    
            // Sauvegarder la commande mise à jour après remboursement partiel ou non
            handleSave(updatedCommande);
        } catch (error) {
            console.error('Erreur lors du remboursement ou du paiement :', error);
        }
    };
    

    const showCancellationPopup = () => {
        const confirmCancel = window.confirm(
            "Le montant est supérieur à la commande originale. Voulez-vous annuler cette commande et rembourser le client ?"
        );
    
        if (confirmCancel) {
            // Annuler la commande et rembourser
            saveCommande(updatedCommande, true); // true signifie qu'on annule la commande
        }
    };

    const AnnulerCommande = async () => {
        setIsUpdating(true);
        try {
            await saveCommande(updatedCommande, true);
        } catch (error) {
            console.error("Erreur lors de l'annulation de la commande:", error);
        } finally {
            setIsUpdating(false);
        }
    }
    

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsUpdating(true);
        if (updatedCommande.montant < commande.montant) {
            // Nouveau montant est inférieur à l'ancien, faire un remboursement partiel
            saveCommande(updatedCommande, false); 
        } else if(updatedCommande.montant == commande.montant){
            handleSave(updatedCommande);
        }
        else {
            // Nouveau montant est supérieur, afficher un popup pour annuler la commande
            showCancellationPopup();
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Modifier la Commande</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Label className="text-gray-800 font-weight-bold">Plats</Form.Label>
                    {updatedCommande.plats && updatedCommande.plats.map((plat, index) => (
                        <div key={index}>
                            <div className="d-flex align-items-center">
                                <Form.Control
                                    type="text"
                                    className="mb-2 mr-2 col-3"
                                    value={plat.nom}
                                    readOnly
                                />

                                {plat.taille == null ? (
                                    <Form.Control
                                        type="text"
                                        className="mb-2 mr-2 col-3"
                                        value={`${plat.prix}€`}
                                        readOnly
                                    />
                                ) : (
                                    <Form.Control
                                        type="text"
                                        className="mb-2 mr-2 col-3"
                                        value={`${plat.prix}€ - ${plat.taille}`}
                                        readOnly
                                    />
                                )}

                                <Form.Control
                                    type="number"
                                    className="mr-2 col-2"
                                    value={plat.quantite}
                                    onChange={(e) => handlePlatChange(index, 'quantite', parseInt(e.target.value, 10))}
                                    min="1"
                                    max={plat.quantiteInitiale}
                                />

                                <Form.Control
                                    type="number"
                                    className="mr-2 col-3"
                                    value={parseFloat(plat.prix * plat.quantite).toFixed(2)}
                                    readOnly
                                />
                                <Button variant="danger" onClick={() => handleRemovePlat(index)}>
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </div>

                            <div className="d-flex align-items-center">
                            {plat.addons && plat.addons.length > 0 && plat.addons.map((addon) => (
                                    <div key={addon.nom} className="mb-4 mr-3">
                                        <strong>{addon.nom}</strong>
                                        {addon.modules.map((module) => (
                                            <Form.Check
                                                key={module.nom}
                                                type="checkbox"
                                                label={`${module.nom} (${module.prix}€)`}
                                                checked={plat.selectedAddons && plat.selectedAddons.some(selectedAddon => 
                                                    selectedAddon.nom === addon.nom && 
                                                    selectedAddon.modules.some(mod => mod.nom === module.nom)
                                                ) || false} // Vérifie spécifiquement si ce module est coché
                                                onChange={() => handleAddonChange(plat.nom, module.nom, module, addon.nom)}
                                            />
                                        ))}
                                    </div>
                                ))}

                            

                                <Form.Group className="mb-4 col-6">
                                    <Form.Label>Instructions spéciales</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={plat.instructions || ''} 
                                        onChange={(e) => handlePlatChange(index, 'instructions', e.target.value)}
                                    />
                                </Form.Group>
                                
                            </div>
                        </div>
                    ))}

                    <div className="col-md-6">
                        <Form.Group controlId="formMontant">
                            <Form.Label>Montant Total</Form.Label>
                            <Form.Control
                                type="text"
                                name="montant"
                                value={`${updatedCommande.montant}€`}
                                readOnly
                            />
                        </Form.Group>
                    </div>

                    <hr />
                    <div className="row">
                    <div className="col-md-6">
                            <Form.Label className="text-gray-800 font-weight-bold">Informations de client</Form.Label>
                           
                            <Form.Group controlId="formNom">
                                <Form.Label>Nom</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="nom"
                                    value={updatedCommande.nom || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group controlId="formPrenom">
                                <Form.Label>Prénom</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="prenom"
                                    value={updatedCommande.prenom || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group controlId="formTele">
                                <Form.Label>Numéro de téléphone</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="tele"
                                    value={updatedCommande.tele || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group controlId="formEmail">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={updatedCommande.email || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group controlId="formAdresse">
                                <Form.Label>Adresse</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="adresse"
                                    value={updatedCommande.adresse || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </div>
                        <div className="col-md-6">
                            <Form.Label className="text-gray-800 font-weight-bold">Informations de commande</Form.Label>
                            
                            <Form.Group controlId="formDateCommande">
                                <Form.Label>Date de commande</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="date_commande"
                                    value={updatedCommande.date_commande || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>

                            <Form.Group controlId="formDateService">
                                <Form.Label>Date de service</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="date_service"
                                    value={updatedCommande.date_service || ''}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            <Form.Group controlId="formStatutPaiement">
                                <Form.Label>Statut de paiement</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="statut_paiement"
                                    value={updatedCommande.statut_paiement || ''}
                                    onChange={handleChange}
                                >
                                    <option value="Payé">Payé</option>
                                    <option value="En attente">En attente</option>
                                    <option value="Rembourssé">Rembourssé</option>
                                </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="formStatutCommande">
                                <Form.Label>Statut de la commande</Form.Label>
                                <Form.Control
                                    as="select"
                                    name="statut_commande"
                                    value={updatedCommande.statut_commande || ''}
                                    onChange={handleChange}
                                >
                                    <option value="En cours">En cours</option>
                                    <option value="Accepté">Accepté</option>
                                    <option value="Annulé">Annulé</option>
                                    <option value="Terminé">Terminé</option>
                                </Form.Control>
                            </Form.Group>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fermer
                </Button>
                <Button variant="danger" onClick={AnnulerCommande}>
               {isUpdating ? <span>Annuler la Commande <span className="spinner-border spinner-border-sm"></span></span> : <span>Annuler la Commande</span>}
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                {isUpdating ? <span>Sauvegarder les modifications <span className="spinner-border spinner-border-sm"></span></span> : <span>Sauvegarder les modifications</span>}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditCommandeModal; 
